import { Component, ElementRef} from '@angular/core';
import { SiriusBaseComponent } from 'sirius-framework';
/*import { SiriusDialogAction } from '@ibtech/sirius-angular-dialog';*/
import { PopupModel } from './popup.model';
import { PopupService } from './popup.service';
declare var $: any;

@Component({
    selector: 'popup',
    templateUrl: './popup.component.html',
    styleUrls: ['./popup.component.css'],
})

export class PopupComponent extends SiriusBaseComponent<PopupModel> {
    isOpen: boolean = false;

    ParentModel: any;
    //@Output() closed = new EventEmitter();

    constructor(private el: ElementRef, private popupService: PopupService) {
        super();
    }

    ngOnInit(): void {

        // add self (this modal instance) to the modal service so it's accessible from controllers
        this.popupService.add(this);
    }

    OnInit() {

    }

  //TODO:
/*  public onActionClick(e: SiriusDialogAction) {*/
       public onActionClick() {
        //if (e.commandName == 'ok') {
        //    this.isOpen = false;
        //}
    }

    //close popup
    public close() {
        try {
            this.isOpen = false;
            $('html').removeClass('dont-move-back');
            if (this.model.onClose != null) {
                this.model.onClose();
            }
        } finally {

        }
    }

    linkBaseEvent(event) {
        if (this.model.linkEvent != null) {
            this.model.linkEvent(event);
        }
    }

    public ok() {
        try {
            this.isOpen = false;
            $('html').removeClass('dont-move-back');
            if (this.model.ok != null) {
                this.model.ok(this.ParentModel);
            }
        } finally {

        }
    }
    public open() {
        this.isOpen = true;
        $('html').addClass('dont-move-back');
        setTimeout(() => {
            var linkEl = this.el.nativeElement.querySelector('a.a3') !== null;
            if (linkEl) {
                this.el.nativeElement.querySelector('a.a3').addEventListener('click', this.linkBaseEvent.bind(this));
            }
        }, 1);

    }

    public closeWithoutEvent() {
        try {
            this.isOpen = false;
            $('html').removeClass('dont-move-back');
        } finally {

        }
    }

}
